module.exports = __webpack_public_path__ + "static/media/star-grey.cedee4b2.svg";